import { useState, useEffect } from "react";

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return isMobile;
}

export const scrollToSection = (sectionId: string, offset = 100) => {
  const tryScroll = () => {
    const section = document.getElementById(sectionId);
    if (section) {
      const y =
        section.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: y, behavior: "smooth" });
      return true;
    }
    return false;
  };

  const isHome = window.location.pathname === "/";
  const found = tryScroll();

  if (!found) {
    if (isHome) {
      let attempts = 0;
      const interval = setInterval(() => {
        if (tryScroll() || attempts > 10) {
          clearInterval(interval);
        }
        attempts++;
      }, 100);
    } else {
      window.location.href = `/#${sectionId}`;
    }
  }
};
